module.exports = __webpack_public_path__ + "img/7.a14b0bdc.jpg";